import type { TFunction } from 'i18next'
import type { AppliedWorkoutContext } from './applyWorkoutAdjustments'

export function coachSignalText(
  t: TFunction,
  logged: number,
  target: number,
  ctx: AppliedWorkoutContext,
  cycleReduced: boolean,
  cyclePhase: string | null,
): string {
  if (ctx.coachNote) return ctx.coachNote
  if (ctx.forceRestDay) return t('coach.signals.recoveryDay')
  if (ctx.volumePct != null && ctx.volumePct < 0) {
    return logged < target
      ? t('coach.signals.volumeReducedBehind', { pct: ctx.volumePct })
      : t('coach.signals.volumeReducedOnTrack', { pct: ctx.volumePct })
  }
  if (cycleReduced) {
    return logged < target
      ? t('coach.signals.cycleReducedBehind')
      : t('coach.signals.cycleReducedOnTrack')
  }
  if (cyclePhase === 'ovulatory') return t('coach.signals.ovulatory')
  return logged < target ? t('coach.signals.oneMoreRep') : t('coach.signals.strongSet')
}
